import React, { useState } from "react";
import Link from "components/ExtendLink";
import { Row, Card, CardBody, CardHeader, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
import LottieLoader from "../LottieLoader";
import lottieLoaderFile from "../../files/animation/loading.json";
import lottieEmptyFile from "../../files/animation/empty_new.json";
import paginationFactory from "react-bootstrap-table2-paginator";
import SendEducationalQuestionnaire from "./SendEducationalQuestionnaries";

function EducationProvideList({ educationProvide, loading, error, pagination, history, patientProfile }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEducationMaterial, setSelectedEducationMaterial] = useState(null);
    const { page, limit, totalCount, data } = educationProvide || {};
    function capitalize(cell) {
        if (cell) {
            return cell.charAt(0).toUpperCase() + cell.slice(1);
        }
    }

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            {"   "}Showing {from} to {to} of {size} Results
        </span>
    );
    const options = {
        page: parseInt(page || 0),
        sizePerPage: parseInt(limit || 0),
        totalSize: parseInt(totalCount || 0),
        firstPageText: "First",
        prePageText: "Back",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        prePageTitle: "Pre page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        hideSizePerPage: parseInt(totalCount) == 0 ? true : false, // Hide the sizePerPage dropdown always
        hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        showTotal: parseInt(totalCount) == 0 ? false : true,
        paginationTotalRenderer: customTotal,
        sizePerPageList: [
            {
                text: "25",
                value: 25,
            },
            {
                text: "50",
                value: 50,
            },
            {
                text: "100",
                value: 100,
            },
            {
                text: "200",
                value: 200,
            },
        ], // A numeric array is also available. the purpose of above example is custom the text
    };

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleViewQuestionnaire = (row) => {
        if(row && row.educationMaterialType){
          setSelectedEducationMaterial(row.educationMaterialType);
        }
        setIsModalOpen(true);
    };

    return (
        <div>
            <Row>
                <Col sm="12" className="mt-12">
                    <div className="scrollbar-table-cls">
                        <BootstrapTable
                            data={loading ? [] : data ? data : []}
                            noDataIndication={() => {
                                return (
                                    <div>
                                        {loading && (
                                            <LottieLoader
                                                loadLoop={true}
                                                autoplayLoop={true}
                                                source={lottieLoaderFile}
                                                Lheight={150}
                                                Lwidth={150}
                                                subTitle={"Please Wait ..."}
                                            />
                                        )}
                                        {!loading && (
                                            <LottieLoader
                                                loadLoop={true}
                                                autoplayLoop={true}
                                                source={lottieEmptyFile}
                                                Lheight={300}
                                                Lwidth={300}
                                                title={"Sorry! No data found"}
                                                subTitle={"No Educational Material Provided to this patient yet."}
                                            />
                                        )}
                                    </div>
                                );
                            }}
                            remote={{
                                sort: false,
                                pagination: true,
                                filter: true,
                                search: true,
                            }}
                            wrapperClasses="table-responsive"
                            keyField="_id"
                            columns={[
                                {
                                    dataField: "educationMaterialType",
                                    text: "Material Type",
                                    sort: true,
                                    formatter: (cell, row) => {
                                        if (cell) {
                                            const { materialType } = cell;
                                            return materialType ? materialType : '-';
                                        } else {
                                            return '-'
                                        }
                                    },
                                },
                                // {
                                //     dataField: "files",
                                //     text: "Education Material Documents/Link",
                                //     formatter: (cell, row) => {
                                //         if (row.files && row.files.length > 0 || row.materialLink && row.materialLink.length > 0) {
                                //             return (
                                //                 <div>
                                //                     {row.files && row.files.length > 0 && (
                                //                         <div>
                                //                             <h5 className="text-left">Education Documents</h5>
                                //                             {row.files.map((item, idx) => (
                                //                                 <div key={idx} className="link-hover">
                                //                                     <a
                                //                                         href={
                                //                                             process.env.REACT_APP_VIDEO_CALL_REQUEST +
                                //                                             "/" +
                                //                                             item.path
                                //                                         }
                                //                                         target="_blank"
                                //                                         rel="noopener noreferrer"
                                //                                         style={{ textDecoration: "none" }}
                                //                                     >
                                //                                         <p style={{ display: "flex", alignItems: "center" }}>
                                //                                             <i
                                //                                                 className="mdi mdi-file-pdf mr-2"
                                //                                                 style={{
                                //                                                     fontSize: 20,
                                //                                                     color: "red",
                                //                                                     marginRight: 6,
                                //                                                 }}
                                //                                             ></i>
                                //                                             <span
                                //                                                 style={{
                                //                                                     color: "#000000",
                                //                                                     textDecoration: "underline",
                                //                                                     fontWeight: 200,
                                //                                                     display: "inline-block",
                                //                                                     maxWidth: "350px",
                                //                                                     whiteSpace: "nowrap",
                                //                                                     overflow: "hidden",
                                //                                                     textOverflow: "ellipsis",
                                //                                                 }}
                                //                                                 title={item.name}
                                //                                             >
                                //                                                 {item.name}
                                //                                             </span>
                                //                                         </p>
                                //                                     </a>
                                //                                 </div>
                                //                             ))}
                                //                         </div>
                                //                     )}
                                //                     {row.materialLink && row.materialLink.length > 0 && (
                                //                         <div>
                                //                             <h5 className="text-left">Education Material Link</h5>
                                //                             {row.materialLink.map((item, idx) => (
                                //                                 <div key={idx} className="link-hover">
                                //                                     <a
                                //                                         href={item}
                                //                                         target="_blank"
                                //                                         rel="noopener noreferrer"
                                //                                         style={{ textDecoration: "none" }}
                                //                                     >
                                //                                         <p style={{ display: "flex", alignItems: "center" }}>
                                //                                             <i
                                //                                                 className="mdi mdi-link mr-2"
                                //                                                 style={{
                                //                                                     fontSize: 20,
                                //                                                     color: "blue",
                                //                                                     marginRight: 6,
                                //                                                 }}
                                //                                             ></i>
                                //                                             <span
                                //                                                 style={{
                                //                                                     color: "#000000",
                                //                                                     textDecoration: "underline",
                                //                                                     fontWeight: 200,
                                //                                                     display: "inline-block",
                                //                                                     maxWidth: "350px",
                                //                                                     whiteSpace: "nowrap",
                                //                                                     overflow: "hidden",
                                //                                                     textOverflow: "ellipsis",
                                //                                                 }}
                                //                                                 title={item}
                                //                                             >
                                //                                                 {item}
                                //                                             </span>
                                //                                         </p>
                                //                                     </a>
                                //                                 </div>
                                //                             ))}
                                //                         </div>
                                //                     )}
                                //                 </div>
                                //             );
                                //         } else {
                                //             return <span>No Documents/Links Provided</span>;
                                //         }
                                //     }
                                // },
                                {
                                    dataField: "message",
                                    text: "Message",
                                    sort: true,
                                    formatter: (cell, row) => {
                                        return row.message ? row.message : '-';
                                    }
                                },
                                {
                                    dataField: "sender",
                                    text: "Provide By",
                                    sort: true,
                                    formatter: (cell, row) => {
                                        if (row.sender) {
                                            const { fname, lname } = row.sender;
                                            return fname && lname ? `${capitalize(fname)} ${capitalize(lname)}` : '-';
                                        } else {
                                            return '-';
                                        }
                                    },
                                    headerStyle: () => {
                                        return { width: "13%" };
                                    }
                                },
                                {
                                    dataField: "createdAt",
                                    text: "Material Send Date",
                                    sort: true,
                                    formatter: (cell, row) => moment(row.createdAt).format("MMMM DD, YYYY hh:mm A"),
                                    headerStyle: () => {
                                        return { width: "14%" };
                                    }
                                },
                                {
                                    dataField: "createdAt",
                                    text: "Action",
                                    formatter: (cell, row) => (
                                        <div className="d-flex ">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-info flex-fill mr-2 questionnaire-btn"
                                                style={{ borderRadius: '10px' }}
                                                title="You can send a questionnaire regarding this material"
                                                onClick={() => handleViewQuestionnaire(row)}
                                            >
                                                <i className="mdi mdi-help-circle-outline"></i> Send questionnaire
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-gradient-info btn-lg font-weight-medium auth-form-btn flex-fill"
                                                style={{ borderRadius: '10px' }}
                                                title="View Details"
                                                onClick={() => {
                                                    history.push({
                                                        pathname: `/education-material-questionnaire-details/${row._id}`,
                                                        state: { from: history.location.pathname, patientProfile : patientProfile } // or any object you want to pass
                                                    });
                                                }}
                                            >
                                                <i className="mdi mdi-eye"></i> View Details
                                            </button>
                                        </div>
                                    ),
                                    headerStyle: () => {
                                        return { width: "6%" };
                                    }
                                },
                            ]}
                            pagination={options.page > 0 ? paginationFactory(options) : undefined}
                            bordered
                            onTableChange={pagination}
                        />
                    </div>
                </Col>
            </Row>
            {isModalOpen && <SendEducationalQuestionnaire toggleModal={toggleModal} isModalOpen={isModalOpen} selectedEducationMaterial={selectedEducationMaterial} patientId={patientProfile && patientProfile._id}/>}
        </div>
    )
}

export default EducationProvideList;